export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT = 'LOGOUT';
export const CHANGE_LANG = 'CHANGE_LANG';

import { post } from 'utils/fetchRequest';

export const login = async (dispatch, data) => {
    try {
        const result = await post('auth', data);

        if (result.code === 200) dispatch({ type: LOGIN_SUCCESS, data: result.data });
        else dispatch({ type: LOGIN_ERROR });

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const logout = (dispatch) => {
    dispatch({ type: LOGOUT });
};

export const changePassword = async (data) => {
    try {
        const result = await post('auth/changepassword', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};
